import React from 'react';

import CircleCheckIcon from 'Assets/icons/circle-check.svg';
import CircleInfoIcon from 'Assets/icons/circle-info.svg';
import HourglassIcon from 'Assets/icons/hourglass.svg';

function PositionFundApprovalsTableRow(props) {
    return (
        <>
            <tr key={props.positionFundApproval.id} className="tw-cursor-pointer" onClick={props.clickHandler}>
                <td>{props.positionFundApproval.position ? props.positionFundApproval.position.name : '-'}</td>
                <td>{props.positionFundApproval.position.supervisor ? props.positionFundApproval.position.supervisor.name : '-'}</td>
                <td>
                    <div className="tw-flex tw-items-center tw-gap-x-3">
                        {props.positionFundApproval.status !== 'PENDING' ? (
                            <>
                                {props.positionFundApproval.status === 'APPROVED' && <CircleCheckIcon className="tw-w-3 tw-h-3 tw-text-green" />}
                                {props.positionFundApproval.status === 'REJECTED' && <CircleInfoIcon className="tw-w-3 tw-h-3 tw-text-red" />}
                            </>
                        ) : (
                            <HourglassIcon className="tw-w-3 tw-h-3 tw-text-blue" />
                        )}
                        {props.positionFundApproval.status_label}
                    </div>
                </td>
                <td>
                    <div>Rate: {props.positionFundApproval.amount_data.rate}</div>
                    <div>Start Date: {props.positionFundApproval.amount_data.start_date}</div>
                    <div>End Date: {props.positionFundApproval.amount_data.end_date}</div>
                </td>
            </tr>
        </>
    );
}

export default PositionFundApprovalsTableRow;
